import apiClient from '@/services/axios'

export async function put(onboardingPerkId, payload) {
  var response = await apiClient.put('/autoperks', payload)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update onboarding perk.')
}
